import { Card, CardContent } from '@mui/material'
import useFetchApi, { FetchingStatus } from 'hooks/useFetchApi/useFetchApi'
import { GiftCardDetailContract } from 'models'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import giftCardService, {
    GiftCardSearchRequest,
} from 'Services/api/giftCard.service'
import { showErrorMessage } from 'store/actions/ui.action'
import usePaymentContext from '../hook/usePaymentContext'
import GiftCardDetail from './GiftCardDetail'
import GiftCardLookup from './GiftCardLookup'
import { PaymentDisplaySection } from '../hook/SectionType'

function GiftCardPaymentSection() {
    const [
        giftCards = [],
        getGiftCards,
        statusGetList,
        ,
        ,
        setGiftCards,
    ] = useFetchApi(giftCardService.getIssuedGiftCards)
    const {
        currencyID,
        orderCustomerID,
        selectedGiftCard,
        onSelectGiftCard,
        onSetDisplaySection,
    } = usePaymentContext()
    const dispatch = useDispatch()
    useEffect(() => {
        const search: GiftCardSearchRequest = {
            customerID: orderCustomerID,
            forceReturn: true,
        }
        getGiftCards(search)
    }, [getGiftCards, orderCustomerID])
    const [giftcard, setGiftCard] = useState<
        GiftCardDetailContract | undefined
    >()
    const [, getByID, statusGetDetailByID, , ,] = useFetchApi(
        giftCardService.getGiftCardDetail,
    )
    const [, getByCode, statusGetDetailByCode, , ,] = useFetchApi(
        giftCardService.getIssuedGiftCardByCode,
    )

    const setGiftcardDetail = useCallback(
        (giftcard: GiftCardDetailContract | undefined) => {
            if (giftcard)
                if (giftcard.currencyID !== currencyID) {
                    dispatch(
                        showErrorMessage("Gift Card's currency is not match"),
                    )
                    setGiftCard(undefined)
                } else {
                    setGiftCard(giftcard)
                }
        },
        [currencyID, dispatch],
    )

    const onSelect = useCallback(
        async (id: string) => {
            try {
                const giftcardDetail = await getByID(id)
                setGiftcardDetail(giftcardDetail)
            } catch (err) {
                dispatch(showErrorMessage(err))
            }
        },
        [dispatch, getByID, setGiftcardDetail],
    )

    const onViewClick = useCallback(
        async (code: string) => {
            try {
                const giftcardDetail = await getByCode(code)
                setGiftcardDetail(giftcardDetail)
            } catch (err) {
                dispatch(showErrorMessage(err))
            }
        },
        [dispatch, getByCode, setGiftcardDetail],
    )

    useEffect(() => {
        //if gift card already selected, by pass select gift card process
        if (selectedGiftCard)
            onSetDisplaySection(PaymentDisplaySection.Calculation)
    }, [onSetDisplaySection, selectedGiftCard])

    return (
        <Card
            variant="outlined"
            sx={(x) => ({
                flexGrow: 1,
            })}
        >
            <CardContent
                sx={(x) => ({
                    height: `calc(75svh - ${x.spacing(2)})`,
                })}
            >
                {giftcard ? (
                    <GiftCardDetail
                        loading={
                            statusGetDetailByID === FetchingStatus.LOADING ||
                            statusGetDetailByCode === FetchingStatus.LOADING
                        }
                        onUpdateGiftcard={(gc) => {
                            setGiftCard(gc)
                            setGiftCards((cs) => {
                                return cs?.map((a) => {
                                    if (a.giftCardID === gc.giftCardID)
                                        a.currentBalance = gc.currentBalance
                                    return a
                                })
                            })
                        }}
                        giftcard={giftcard}
                        onBack={() => {
                            setGiftCard(undefined)
                            onSelectGiftCard(undefined)
                        }}
                    />
                ) : (
                    <GiftCardLookup
                        giftCards={giftCards}
                        onView={onViewClick}
                        onSelect={onSelect}
                        loading={statusGetList === FetchingStatus.LOADING}
                    />
                )}
            </CardContent>
        </Card>
    )
}

export default GiftCardPaymentSection
